import { mds, prizm, prizmNext } from '4ff-lib-foundation/lib/components/themes';
import merge from 'lodash.merge';
import customMds from './mds';
import customPrizm from './prizm';
import customPrizmNext from './prizmNext';

export const themeSelector = (themeName) => {
  switch (themeName) {
    case 'mds':
      return merge(mds, customMds);
    case 'prizm':
      return merge(prizm, customPrizm);
    case 'prizm-next':
      return merge(prizmNext, customPrizmNext);
    default:
      return merge(prizm, customPrizm);
  }
};

export {
  customMds,
  customPrizm,
  customPrizmNext,
};
